<div class="bg-black rounded-xl overflow-hidden text-white flex-start-center cursor-pointer hover:shadow-lg" (click)="linkToBot()">
    <div *ngIf="type === 'hunter_agent'" class="min-w-[78px] h-[130px] relative">
        <img src="/assets/imgs/hemera-bot.png" class="rounded-full min-w-[130px] w-[130px] h-[130px] right-0 top-0 absolute" alt="" />
    </div>

    <div *ngIf="type === 'nyx_agent'" class="min-w-[88px] h-[130px] relative">
        <img src="/assets/imgs/nyx-bot.png" class="rounded-full min-w-[130px] w-[130px] h-[130px] right-0 top-0 absolute" alt="" />
    </div>

    <div class="relative">
        <div class="flex-start-center gap-x-2 font-semibold">
            <span class="text-base">{{ title }}</span>
            <img src="/assets/imgs/telegram.png" class="w-5 h-5" alt="" />
        </div>

        <div class="mt-2 text-[11px] text-sub-text pr-6">{{ description }}</div>
    </div>
</div>
